export default __webpack_public_path__ + "static/media/studio-experience-banner.d8e9e573.svg";